export enum ManagerTabValues {
    Employees = 'employees',
    Products = 'products',
}
